/* Template: Carousel
   ========================================================================== */

template.component.carousel = function() {
	const $carousel = $('[data-carousel]');
	const $carouselTabs = $('[data-carousel-tab]');
	const activeTabClass = 'active';

	const setActiveTab = function(tabIndex) {
		$carouselTabs.removeClass(activeTabClass);
		$carouselTabs.eq(tabIndex).addClass(activeTabClass);
	};

	if ($carousel.length) {
		$carousel.slick({
			autoplay: true,
			prevArrow: '<div class="slick-arrow slick-prev"><img src="/app/themes/charitypress-rd-look-ahead/images/icon_prev.png" class="" /></div>',
			nextArrow: '<div class="slick-arrow slick-next"><img src="/app/themes/charitypress-rd-look-ahead/images/icon_next.png" class="" /></div>',
		});

		$carousel.on('afterChange', function(event, slick, currentSlide) {
			setActiveTab(currentSlide);
		});

		$carouselTabs.on('click', function() {
			const slideIndex = parseInt($carouselTabs.index(this));

			setActiveTab(slideIndex);
			$carousel.slick('slickGoTo', slideIndex, false);
		});
	}
};
